import { keyframes } from 'styled-components/macro';
import { css, styled } from '../theme';
import { AspectRatio } from './media.types';

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.96) translateY(6px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
`;

export const RootWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const ThumbnailsGrid = styled.div<{ $columns: number }>`
  ${({ theme, $columns }) => css`
    display: grid;
    gap: ${theme.spacings.xs};
    grid-template-columns: repeat(${$columns}, 1fr);
  `}
`;

export const ThumbnailWrapper = styled.div<{
  $ratio: AspectRatio;
}>`
  ${({ theme, $ratio }) => css`
    position: relative;
    aspect-ratio: ${$ratio.replace(':', ' / ')};
    border-radius: ${theme.radiuses.xs};
    overflow: hidden;
    cursor: pointer;
    background: ${theme.colors.gray[100]};
    animation: ${fadeIn} 280ms ease both;
    transition-duration: 200ms;
  `}
`;

export const ThumbnailOverlay = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
`;
